import { Component, HostListener, Inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatDialogModule, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-update-required-dialog',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    MatIconModule
  ],
  templateUrl: './update-required-dialog.component.html'
})
export class UpdateRequiredDialogComponent implements OnDestroy {
  currentVersion: string;
  requiredVersion: string;
  platform: 'windows' | 'mac' | 'other';
  modifierPressed = false;
  rPressed = false;

  constructor(
    public dialogRef: MatDialogRef<UpdateRequiredDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { currentVersion: string; requiredVersion: string }
  ) {
    this.dialogRef.disableClose = true;
    this.currentVersion = data.currentVersion;
    this.requiredVersion = data.requiredVersion;
    this.platform = this._detectPlatform();
  }

  @HostListener('window:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent): void {
    if (event.key === 'Control' || event.key === 'Meta') {
      this.modifierPressed = true;
    }
    if (event.key.toLowerCase() === 'r') {
      this.rPressed = true;
      if (event.ctrlKey || event.metaKey) {
        event.preventDefault();
        setTimeout(() => this.reloadApp(), 400);
      }
    }
  }

  @HostListener('window:keyup', ['$event'])
  onKeyUp(event: KeyboardEvent): void {
    if (event.key === 'Control' || event.key === 'Meta') {
      this.modifierPressed = false;
      this.rPressed = false;
    }
    if (event.key.toLowerCase() === 'r') {
      this.rPressed = false;
    }
  }

  ngOnDestroy(): void {
    this.modifierPressed = false;
    this.rPressed = false;
  }

  async reloadApp(): Promise<void> {
    // Wyczyść cache przeglądarki
    if ('caches' in window) {
      const names = await caches.keys();
      await Promise.all(names.map(name => caches.delete(name)));
    }
    // Wyrejestruj Service Workera
    if ('serviceWorker' in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map(reg => reg.unregister()));
    }
    window.location.reload();
  }

  private _detectPlatform(): 'windows' | 'mac' | 'other' {
    const ua = navigator.userAgent.toLowerCase();
    const isMobile = /iphone|ipad|ipod|android|mobile/.test(ua);
    const isIPadOS = ua.includes('mac') && (navigator.maxTouchPoints > 1 || 'ontouchstart' in window);
    if (isMobile || isIPadOS) return 'other';
    if (ua.includes('mac')) return 'mac';
    if (ua.includes('win')) return 'windows';
    return 'other';
  }
}
